import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./tailwind.output.css";

ReactDOM.render(<App />, document.getElementById("root"));
